import Choices from 'choices.js'
import EventBus from '../_event-bus'
import RequestHelper from '../_request-helper'
import { $$ } from '../_utils'
import Vue from 'vue'

const GET_LOCALITIES_ENDPOINT = process.env.GET_LOCALITIES_ENDPOINT

Vue.component('vue-select', {
  template: '#vue-select-template',
  props: {
    links: Array,
    noLinks: Boolean,
    type: String,
    wrapperName: String,
    search: Boolean,
    selectedChoice: String,
  },
  data() {
    return {
      select: [],
      choice: '',
      searchFloor: 1,
      choices: [],
      choicesInstance: null,
      searchText: '',
      localitiesEndpoint: GET_LOCALITIES_ENDPOINT,
      searchTimeout: null,
    }
  },

  methods: {
    init() {
      this.setChoices(this.$props.links)
      if (this.$props.search) this.searchFloor = ''
      this.choicesInstance = new Choices(this.select, {
        searchEnabled: true,
        searchFloor: this.searchFloor,
        shouldSort: false,
        choices: this.choices,
        itemSelectText: '',
        noChoicesText: '',
        searchResultLimit: 30,
      })
      EventBus.$on('isShippingSame-changed', data => {
        if (this.$props.type === 'shippingLocality') {
          this.setChoices(data.choices)
          this.setSelectedChoice(data.choice)
        }
      })
      this.setSelectedChoice(this.$props.selectedChoice)
      this.handleChoice()
      this.setSearchListener()
    },
    handleLink(linkTo) {
      if (linkTo !== document.location.href) document.location.href = linkTo
    },
    emitChoice(choice) {
      switch (this.$props.wrapperName) {
        case 'tax-office':
          EventBus.$emit('tax-office-selected', { choice: choice, name: 'taxOffice' })
          break
        case 'register':
          const registerForm = document.forms['register']
          document.forms['register'].elements['userRole'].value = choice
          break
        case 'locality':
          EventBus.$emit('locality-selected', { choice: choice, name: 'locality' })
          break
        case 'shippingLocality':
          EventBus.$emit('shipping-locality-selected', {
            choice: choice,
            name: 'shippingLocality',
          })
          break
        default:
          EventBus.$emit('date-selected', {
            choice: choice,
            type: this.$props.type,
            name: this.$props.wrapperName,
          })
      }
    },
    setChoices(choices) {
      this.choices = choices
    },
    handleChoice() {
      this.select.addEventListener('choice', event => {
        if (!this.$props.noLinks) {
          this.handleLink(event.detail.choice.value)
        } else {
          if (event.detail.choice.value !== this.choice) {
            this.emitChoice(event.detail.choice.value)
            this.choice = event.detail.choice.value
          }
        }
      })
    },
    setSelectedChoice(choice) {
      if (choice) {
        this.choicesInstance.setChoices(this.choices, 'value', 'label', true)
        if (this.$props.type === 'tax-office-select') {
          this.choice = this.choices.filter(item => item.value == choice)
          this.choicesInstance.setChoiceByValue(this.choice[0].value)
        } else {
          this.choicesInstance.setChoiceByValue(choice)
          this.choice = choice
        }
      }
    },
    handleSearch(event) {
      if (!event) return
      if (event.detail.value.length >= 3) {
        if (this.searchTimeout) window.clearTimeout(this.searchTimeout)
        this.searchTimeout = window.setTimeout(() => {
          this.choicesInstance.setChoices(() =>
            this.makeRequest(`${this.localitiesEndpoint}?search=${event.detail.value}`)
          )
        }, 2000)
      } else if (event.detail.value.length === 1) {
        this.choices = []
        this.choicesInstance.setChoices(this.choices, 'value', 'label', true)
      }
    },
    setSearchListener() {
      if (!this.$props.search) return
      this.select.addEventListener('search', this.handleSearch)
    },
    async makeRequest(endpoint) {
      try {
        // for local tests only:

        // const data = [
        //   { label: 'Łódź, woj.łódzkie', value: 'Łódź, woj.łódzkie' },
        //   { label: 'Łódź, woj.wielkopolskie', value: 'Łódź, woj.wielkopolskie' },
        // ]
        // this.choices = data
        // this.emitRequestedChoices(data, this.$props.type)
        // return data

        //for production only:

        const { data } = await RequestHelper.get(endpoint)
        this.choices = data
        this.emitRequestedChoices(data, this.$props.type)
        return data
      } catch (err) {
        console.error(`err =>`, err)
      }
    },
    emitRequestedChoices(data, type) {
      switch (type) {
        case 'locality':
          EventBus.$emit('localities-changed', { choices: data, type: type })
          break
        case 'shippingLocality':
          EventBus.$emit('shippingLocalities-changed', { choices: data, type: type })
          break
        default:
          break
      }
    },
  },
  created() {},
  mounted() {
    this.select = this.$refs.select
    this.init()
  },
})

window.addEventListener('DOMContentLoaded', () => {
  $$('#vue-select-wrapper').forEach(el => new Vue({ el }))
})
